module.exports = __webpack_public_path__ + "static/img/new_btn2.c45c6210.png";